export const PORT = "port"
export const AREA_REGIONAL = "area_regional"
export const AREA_GLOBAL = "area_global"
